// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2LnPn","label":"Section_label__30pTM","contentWrap":"Section_contentWrap__fUAZX","footer":"Section_footer__2ZG2U","footerInner":"Section_footerInner__1cxvg"};